module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel202309_03_1280_1280_ja-5c52b1fb3b3bba7ac33f0218b8183a57.jpg";